import { Actions, createSessionStorageStore } from '@bpd-library/utilities';

import { SESSION_STORAGE_NAME } from './utilities/constants';
import { UserProjectPhase, UserState } from './utilities/store.types';

type UserStoreAction = 'init' | 'clearUser' | 'updateWishlist' | 'addProject';

const initialState = {
    loggedIn: false,
};

const actions: Actions<UserStoreAction, UserState> = {
    init: (state: UserState, newState: UserState) => {
        state.info = newState.info;
        state.wishlist = newState.wishlist;
        state.areas = newState.areas;
        state.projects = newState.projects;
        state.propertyTypes = newState.propertyTypes;
        state.loggedIn = newState.loggedIn;
        return state;
    },
    clearUser: (state: UserState) => {
        state.info = undefined;
        state.wishlist = undefined;
        state.areas = undefined;
        state.projects = undefined;
        state.propertyTypes = undefined;
        state.loggedIn = false;

        return state;
    },
    updateWishlist: (state: UserState, newWishlist: string[]) => {
        state.wishlist = [...newWishlist];

        return state;
    },
    addProject: (state: UserState, newProjects: UserProjectPhase[]) => {
        if (state.projects) {
            state.projects = [...state.projects, ...newProjects];
        } else {
            state.projects = newProjects;
        }

        return state;
    },
};

// User store needs to be persistant in session.
export const userStore = createSessionStorageStore<UserState, UserStoreAction>({
    key: SESSION_STORAGE_NAME,
    initialState,
    actions,
    initAction: 'init',
});

export const updateUser = (newState: UserState) => {
    userStore.dispatch('init', newState);
};

export const clearUser = () => {
    userStore.dispatch('clearUser');
};

export const updateWishlist = (newWishlist: string[]) => {
    userStore.dispatch('updateWishlist', newWishlist);
};
